export default {
    methods: {
        getBlockImage(block) {
            switch (block.block_type) {
                case 1: // image
                    return require('../../../images/icons/image.png');
                case 2: // video
                    return require('../../../images/icons/video.jpg');
                case 3: // speaker
                    return require('../../../images/icons/speaker.png');

                default:
                    return require('../../../images/icons/image.png');
            }
        },

    },
};
